import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Gigs from '../views/Gigs.vue'
import Merch from '../views/Merch.vue'
import ContactUs from '../views/ContactUs.vue'
import Cart from '../views/Cart.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gigs',
    name: 'Gigs',
    component: Gigs
  },
  {
    path: '/merch',
    name: 'Merch',
    component: Merch
  },
  {
    path: '/contactus',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
